// Session helper for auth state management.
//
// PRIMARY AUTH: httpOnly cookie (set by backend on login, sent automatically via withCredentials).
//   This is the secure auth mechanism — page refresh, cross-tab, all axios calls.
//
// FALLBACK: In-memory token variable (NOT persisted to localStorage).
//   Kept for backward compatibility with raw fetch() calls in page components
//   during the current page session. Lost on page refresh — cookie takes over.
//   This is NOT stored in localStorage to prevent XSS exfiltration.
import { STORAGE_KEYS } from "./constants";

const readJSON = (k) => {
  try {
    const v = localStorage.getItem(k);
    return v ? JSON.parse(v) : null;
  } catch (e) {
    return null;
  }
};

const writeJSON = (k, v) => {
  try {
    if (v === null || v === undefined) {
      localStorage.removeItem(k);
    } else {
      localStorage.setItem(k, JSON.stringify(v));
    }
    return true;
  } catch (e) {
    return false;
  }
};

const session = {
  // Token is in-memory only (not localStorage) — used as fallback for raw fetch() calls
  _token: null,
  user: readJSON(STORAGE_KEYS.USER_DATA) || null,

  setToken(t) {
    // Store in memory only — NOT in localStorage (XSS protection)
    this._token = t || null;
  },

  getToken() {
    // Returns in-memory token (available only during current page session)
    return this._token;
  },

  setUser(u) {
    this.user = u || null;
    writeJSON(STORAGE_KEYS.USER_DATA, this.user);
  },

  getUser() {
    return this.user;
  },

  clear() {
    this._token = null;
    this.user = null;
    try {
      localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USER_DATA);
    } catch (e) {
      // ignore
    }
  },
};

export default session;
